export default "__VITE_ASSET__Cg9h2DVD__"